import React, { useState } from "react"
import { defineMessages, FormattedMessage, injectIntl } from "react-intl"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import AuthService from "../../state/auth/AuthService"
import LoadingSpinner from "../../common/spinner/loading.component"
import { Button, Alert } from "react-bootstrap"
import ReactCodeInput from "react-verification-code-input"
import { Intl } from "../../state/helpers/IntlProps"

const messages = defineMessages({
    greetings_text: {
        id: "auth.greeting.text",
        defaultMessage: "Thank you for signing up, {name}!",
    },
    email_sent_message: {
        id: "auth.email_sent",
        defaultMessage: "An email has been successfully sent to {value}",
    },
    email_address_label: {
        id: "auth.verify_code_prompt",
        defaultMessage: "Please enter the verification code below",
    },
    verification_resend_label: {
        id: "auth.resend_verification_code",
        defaultMessage: "Resend Verification Code",
    },
    email_resend_message: {
        id: "auth.resend_code_label",
        defaultMessage:
            "Verification code have been sent to {email}. Please check your inbox.",
    },
    incorrect_verification_code_label: {
        id: "auth.incorrect_verification_code_label",
        defaultMessage: "Please verify your code and try again.",
    },
    resend_code_button_label: {
        id: "auth.resend_code_button",
        defaultMessage: "Resend Verification Code",
    },
})

const errorMessages = defineMessages({
    invalid_code: {
        id: "auth.invalid_code",
        defaultMessage: "Please verify your code and try again.",
    },

    failure_to_resend_code: {
        id: "auth.resend_failure",
        defaultMessage:
            "Unable to resend verification code to {email}. Please try again or contact support.",
    },
})

type Props = {
    intl: Intl
    onAccountVerified: (verified: boolean) => void
}

const AccountVerificationComponent = (props: Props) => {
    const [errorMessage, setErrorMessage] = useState("")
    const [verificationEmailSent, setVerificationEmailSent] = useState(false)
    const [loading, setLoading] = useState(false)
    const email = AppContext.getUserLoggedIn().attributes.email
    const name = AppContext.getUserLoggedIn().attributes.name

    const onSubmit = async (value: string) => {
        const authCodeIsValid = await AuthService.VerifyAuthCode(value)
        if (authCodeIsValid) {
            setErrorMessage("")
            props.onAccountVerified(true)
        } else {
            setErrorMessage(props.intl.formatMessage(errorMessages["invalid_code"]))
        }
        setLoading(false)
        setVerificationEmailSent(false)
    }

    const handleVerificationCodeChange = (value) => {
        if (value.length == 6) {
            setLoading(true)
            setTimeout(() => {
                onSubmit(value)
            }, 1000)
        }
    }

    const sendVerificationCode = async () => {
        const res = await AuthService.SendAuthCodeEmail()
        if (!res) {
            setErrorMessage(
                props.intl.formatMessage(errorMessages["failure_to_resend_code"], {
                    email: email,
                })
            )
        } else {
            setErrorMessage("")
            setVerificationEmailSent(true)
        }
    }

    return (
        <div className="row py-0 justify-content-center pb-5">
            <div className={"col-12 mb-3"}>
                {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
                {verificationEmailSent && (
                    <div className="mt-2">
                        <Alert variant="primary">
                            <FormattedMessage
                                {...messages.email_resend_message}
                                values={{ email: email }}
                            />
                        </Alert>
                    </div>
                )}

                <div className="row py-0 justify-content-center">
                    <h3 className="text-center custom-lead text-custom-primary mb-4 mt-4">
                        <FormattedMessage
                            {...messages.greetings_text}
                            values={{ name: name }}
                        />
                    </h3>
                </div>

                <div className="col-12 row py-0 justify-content-center mt-4">
                    <FormattedMessage
                        {...messages.email_sent_message}
                        values={{ value: email }}
                    />
                </div>
                <form name="input_code">
                    <div className="row py-0 justify-content-center mt-4 acct-verification-code">
                        <ReactCodeInput
                            type="text"
                            fields={6}
                            onChange={(e) => handleVerificationCodeChange(e)}
                        />
                    </div>
                    <div className="row py-0 justify-content-center mt-4">
                        {loading && (
                            <Button
                                type="button"
                                variant="contained"
                                disabled
                                className={"btn btn-primary"}
                            >
                                <LoadingSpinner height={18} />
                            </Button>
                        )}
                    </div>
                </form>
                <div className="row py-0 justify-content-center mt-2">
                    <Button
                        variant="link"
                        disabled={verificationEmailSent}
                        onClick={sendVerificationCode}
                    >
                        <FormattedMessage {...messages.resend_code_button_label} />
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default injectIntl(AccountVerificationComponent)



// WEBPACK FOOTER //
// ./src/auth/components/AccountVerificationComponent.tsx